import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';
import { ComponentLibraryModule } from '@mc-dxp/dxp-web-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataService } from './services/data.service';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';
import { HeaderComponent } from './common/header/header.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { LoggingService } from './services/logging.service';
import { ErrorHandlerService } from './services/error-handler.service';
import { ApiInterceptor } from './common/interceptors/api.interceptor';
import { ToasterComponent } from './common/toaster/toaster.component';
import { ConnectHelper } from './Utility/ConnectHelper';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';
import { CookieService } from 'ngx-cookie-service';
import { XBCCommonModule } from './common/xbc-common.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    DashboardComponent,
    ToasterComponent,
    PageNotFoundComponent
  ],
  imports: [
    ComponentLibraryModule,
    AgGridModule,
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    XBCCommonModule,
    AppRoutingModule
  ],
  providers: [
    DataService,
    AuthService,
    CommonService,
    LoggingService,
    DatePipe,
    ConnectHelper,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    CookieService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
